import React, {Component} from 'react';
import PropTypes from 'prop-types';
import deburr from 'lodash/deburr';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import red from '@material-ui/core/colors/red';

function renderInput(inputProps) {
  const { InputProps, classes, ref, error, ...other } = inputProps;

  return (
    <TextField
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput,
        },
        ...InputProps,
      }}
      FormHelperTextProps={{error, classes: {root: classes.formHelperTextRoot}}}
      error={error}
      {...other}
    />
  );
}

function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

  return (
    <MenuItem
      {...itemProps}
      key={suggestion.text}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
    >
      {suggestion.text}
    </MenuItem>
  );
}
renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.string,
  suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    paddingTop: theme.spacing.unit * 2
  },
  paper: {
    position: 'absolute',
    zIndex: 2,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  inputRoot: {
    flexWrap: 'wrap',
  },
  inputInput: {
    width: 'auto',
    flexGrow: 1,
  },
  formHelperTextRoot: {
    fontSize: '12px !important',
    margin: '0 !important',
    color: `${red[500]} !important`
  }
});

class AutoComplete extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: ''
    }
  }

  render() {
    const { classes, suggestions, id, label, onInputValueChange, onSelect, disabled, initialInputValue, error, helperText } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
        <Downshift 
          id={id}
          initialInputValue={initialInputValue}
          selectedItem={value}
          onStateChange={changes => {
            if (changes.hasOwnProperty('selectedItem')) {
              this.setState({value: changes.selectedItem})
              return typeof onSelect !== 'undefined' ? onSelect(changes.selectedItem) : null;
            } else if (changes.hasOwnProperty('inputValue')) {
              this.setState({value: changes.inputValue})
              return typeof onInputValueChange !== 'undefined' ? onInputValueChange(changes.inputValue) : null;
            }
          }}
        >
          {({
            getInputProps,
            getItemProps,
            getMenuProps,
            highlightedIndex,
            inputValue,
            isOpen,
            selectedItem,
          }) => (
            <div className={classes.container}>
              {renderInput({
                fullWidth: true,
                classes,
                label,
                disabled,
                error,
                helperText,
                InputProps: getInputProps(),
              })}
              <div {...getMenuProps()}>
                {isOpen ? (
                  <Paper className={classes.paper} square>
                    {suggestions.map((suggestion, index) =>
                      renderSuggestion({
                        suggestion,
                        index,
                        itemProps: getItemProps({ item: suggestion.text }),
                        highlightedIndex,
                        selectedItem,
                      }),
                    )}
                  </Paper>
                ) : null}
              </div>
            </div>
          )}
        </Downshift>
      </div>
    );
  }
}

AutoComplete.propTypes = {
  classes: PropTypes.object,
  suggestions: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onInputValueChange: PropTypes.func,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  initialInputValue: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

export default withStyles(styles)(AutoComplete);



// WEBPACK FOOTER //
// ./registration-react/components/AutoComplete.js